module.exports = __webpack_public_path__ + "img/image_3.c1ac9555.png";